import Router from 'vue-router'
import Vue from 'vue'
import account from '@src/router/account/index'
import bill from './bill'
import payment from './payment'
// import components from '@src/router/components/index'
import home from '@src/router/home/index'
import shore from '@src/router/store/index'
import paperless from './paperless'

Vue.use(Router)

export default new Router({
//const router = new Router({
  linkActiveClass: 'active',
  // mode: 'history',
  routes: [
    ...home.routes,
    // ...components.routes,
    ...account.routes,
    ...shore.routes,
    ...bill.routes,
    ...payment.routes,
    ...paperless.router,
    {
      path: '*', // 其他页面，重定向至首页
      redirect: '/401', // 404.html
      meta: { title: '', first: false, resourceCode: '' }
    },
    {
      path: '/401',
      name: '401',
      component: () => import('@/views/errorPage/401'),
      meta: { title: '', first: false, resourceCode: '' }
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/errorPage/404'),
      meta: { title: '', first: false, resourceCode: '' }
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/views/errorPage/403'),
      hidden: true,
      meta: { title: '', first: false, resourceCode: '' }
    },
    {
      path: '/wxreturn',
      name: 'wxreturn',
      component: () => import('@/views/wxreturn/index'),
      hidden: true,
      meta: { title: '', first: false, resourceCode: '' }
    },
    {
      path: '/500',
      name: '500',
      component: () => import('@/views/errorPage/500'),
      hidden: true,
      meta: { title: '', first: false, resourceCode: '' }
    }
  ]
})
// // 解决点击菜单偶尔没反应的问题（chunk 加载失败）
// router.onError((error) => {
//   const msg = error && error.message ? error.message : ''
//   if (msg.includes('Loading chunk')) {
//     console.error('【Chunk 加载失败】', msg)
//     if (window.confirm('页面资源已更新，需要刷新页面才能继续，是否刷新？')) {
//       window.location.reload()
//     }
//   }
// })
// export default router



// WEBPACK FOOTER //
// ./src/router/index.js